<div class="banned-group">
  <div class="banned-group-header">
    <span class="banned-group-label">{{ group.label }}</span>
    <span class="banned-group-count">{{ countLabel }}</span>
  </div>
  <div class="banned-pills">
    <span class="banned-plate-wrap"
          *ngFor="let plate of group.samplePlates"
          role="link"
          tabindex="0"
          (click)="onPillClick(plate)"
          (keydown.enter)="onPillClick(plate)">
      <pla-plate [rawPlate]="plate"
                 [showPrice]="false"
                 [customClass]="'flat shaded'"
                 [xSmallPlate]="true"
                 [openModal]="false"
                 [clickThrough]="false"
                 [noMargin]="true"></pla-plate>
    </span>
    <span class="banned-pills-more" *ngIf="remainder > 0">+{{ remainder }} more</span>
  </div>
</div>
